module.exports = __webpack_public_path__ + "img/delivery.6a4e6bc0.png";